import { toTitleCase } from "../../../../Utils/stringUtls";
import { currencies } from "../../GeneralInformation/ContractAndPaymentTerms";
const ContractAndPaymentTerms = ({ data }) => {
  const {
    cpt_contract_status,
    cpt_expiryDate,
    cpt_setupCost,
    cpt_setupCostCurrency,
    cpt_minStartDate,
    cpt_additional_information,
    cpt_payment_terms,
    cpt_type_of_i2c_pricing,
  } = data["1_1"];
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid gap-sm" className="">
        <div
          i2c-grid="12@md"
          className="mt-24 fw-700 font-bold review-summary-sub-heading"
        >
          Contract and Payment Terms
        </div>
        <div i2c-grid="12">
          <div className="overview-help-text font-bold">Contact Status</div>
          <div className="overview-val-text">
            {cpt_contract_status?.length
              ? toTitleCase(cpt_contract_status)
              : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Expiry Date</div>
          <div className="overview-val-text">
            {cpt_expiryDate?.length ? cpt_expiryDate : "-"}
          </div>
        </div>

        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Setup Cost (
            {
              currencies.find((curr) => curr.label === cpt_setupCostCurrency)
                .value
            }
            )
          </div>
          <div className="overview-val-text">
            {cpt_setupCost?.length ? cpt_setupCost : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Monthly Minimum Start Date
          </div>
          <div className="overview-val-text">
            {cpt_minStartDate?.length ? cpt_minStartDate : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Payment Terms</div>
          <div className="overview-val-text">
            {cpt_payment_terms?.length ? toTitleCase(cpt_payment_terms) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Additional Information
          </div>
          <div className="overview-val-text">
            {cpt_additional_information?.length
              ? toTitleCase(cpt_additional_information)
              : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Type of i2c Inc. Pricing Selected
          </div>
          <div className="overview-val-text">
            {cpt_type_of_i2c_pricing?.length
              ? toTitleCase(cpt_type_of_i2c_pricing)
              : "-"}
          </div>
        </div>
      </div>
    </div>
  );
};
export default ContractAndPaymentTerms;
